const handleErrorList = (actionName, error, setErrorListModalState, appNotify) => {
    var { details } = error;
    if (!details) {
        appNotify(error.message ? `${actionName} failed: ${error.message}` : 'Import failed', 'error');
        return;
    }
    if (details.length === 1) {
        var [firstDetails] = details;
        appNotify(firstDetails, 'error');
        return;
    }

    setErrorListModalState({ header: `${actionName} failed for the following reasons`, details })
    const options = {
        showDetailsButton: true
    }

    appNotify(`${actionName} failed`, 'error', options);
}

export { handleErrorList }